var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBtnWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6328 10.6342C10.9452 10.3218 11.4517 10.3218 11.7641 10.6342L15.9984 14.8685L20.2328 10.6342C20.5452 10.3218 21.0517 10.3218 21.3641 10.6342C21.6765 10.9466 21.6765 11.4532 21.3641 11.7656L17.1298 15.9999L21.3641 20.2342C21.6765 20.5466 21.6765 21.0532 21.3641 21.3656C21.0517 21.678 20.5452 21.678 20.2328 21.3656L15.9984 17.1313L11.7641 21.3656C11.4517 21.678 10.9452 21.678 10.6328 21.3656C10.3203 21.0532 10.3203 20.5466 10.6328 20.2342L14.8671 15.9999L10.6328 11.7656C10.3203 11.4532 10.3203 10.9466 10.6328 10.6342Z",
    fill: "#23262F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtnWhite);
export default __webpack_public_path__ + "static/media/close-btn-white.eedabf3840104c1063a4a8c146b6d0b9.svg";
export { ForwardRef as ReactComponent };